import React from "react";
import { SEO, MainLayout, ForgotPassword } from "../../../components";

const ForgotPasswordPage = () => {
  return (
    <>
      <SEO title="Forgot Password" />
      <MainLayout>
        <ForgotPassword />
      </MainLayout>
    </>
  );
};

export default ForgotPasswordPage;
